<ion-header>
  <app-no-internet-connection></app-no-internet-connection>
  <app-ionic-update-error></app-ionic-update-error>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="closeModal()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title mode="ios" style="padding-inline: 32px">{{
      "reservation-app.your-active-coupons" | translate
    }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid *ngIf="loading">
    <ion-row style="width: 100%">
      <ion-col class="ion-text-center">
        <ion-spinner> </ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid *ngIf="!loading" style="max-width: 700px" class="padding">
    <ion-item
      *ngIf="allCartProductsPromo && cartProducts && cartProducts.length"
      class="error-item"
      lines="none"
    >
      <ion-label class="ion-text-center ion-no-margin ion-text-wrap">
        <ion-text style="font-size: small; font-weight: bold" color="danger"
          >{{
            "reservation-app.cart-active-coupons.cart-products-cant-get-coupon"
              | translate
          }}
        </ion-text>
      </ion-label>
    </ion-item>
    <ion-item
      *ngFor="let coupon of activeCoupons; let i = index; trackBy: trackFunc"
      class="item item-text-wrap item-icon-left cartCoupons cartButtonsWithBordersStyle"
    >
      <ion-label class="ion-text-wrap">
        <strong
          *ngIf="
            coupon.discount &&
            coupon.discountType &&
            (coupon.discountType === 'percent' ||
              coupon.discountType === 'fixed')
          "
          >-{{
            coupon.discount + (coupon.discountType === "percent" ? "%" : "€")
          }}&nbsp;</strong
        >

        <strong
          *ngIf="
            coupon.discount_percent &&
            coupon.discount_fixed &&
            coupon.discountType &&
            coupon.discountType === 'combined'
          "
        >
          -{{ coupon.discount_percent }}% & -{{ coupon.discount_fixed }}€
          &nbsp;</strong
        >

        <strong
          *ngIf="
            !(
              (coupon.discountType !== 'percent' &&
                coupon.discountType !== 'combined' &&
                coupon.discount) ||
              (coupon.discountType === 'combined' &&
                coupon.discount_percent &&
                coupon.discount_fixed)
            ) &&
            coupon.product_id &&
            !coupon.classic_offer_product
          "
        >
          {{ "free" | translate }}
        </strong>

        <strong
          *ngIf="
            !(
              (coupon.discountType !== 'percent' &&
                coupon.discountType !== 'combined' &&
                coupon.discount) ||
              (coupon.discountType === 'combined' &&
                coupon.discount_percent &&
                coupon.discount_fixed)
            ) &&
            coupon.product_id &&
            coupon.classic_offer_product &&
            coupon.tag_comment
          "
        >
          {{ coupon.tag_comment }}
        </strong>

        {{
          coupon.description_langs &&
          (coupon.description_langs[selectedLanguage] ||
            coupon.description_langs[selectedLanguage])
            ? coupon.description_langs[selectedLanguage] ||
              coupon.description_langs[selectedLanguage]
            : coupon.description_langs && coupon.description_langs[mo_base]
            ? coupon.description_langs[mo_base]
            : coupon.description
        }}
        <p
          style="
            font-size: x-small;
            font-weight: 700;

            line-height: 1.4;
          "
          [ngClass]="{ cartWarningLightColor: !coupon.validDate }"
          *ngIf="coupon.activeFrom || coupon.activeTo"
        >
          {{ "reservation-app.cart-active-coupons.valid" | translate }}&nbsp;

          {{ "reservation-app.cart-active-coupons.from" | translate }}
          {{
            coupon.activeFrom
              ? (coupon.activeFrom | date : "dd/MM/yyyy HH:mm")
              : ""
          }}

          {{ "reservation-app.cart-active-coupons.to" | translate }}
          {{ coupon.activeTo ? (coupon.activeTo | date : "dd/MM/yyyy") : "" }}
        </p>
        <!-- <p style="font-size: small;" *ngIf=" !coupon.validDate  && coupon.validDateException">
          <ion-text color="danger">
            {{"reservation-app.cart-active-coupons.today-exceptionally-you-cant-use-the-coupon" |
            translate}}
          </ion-text>
        </p> -->
        <p
          style="
            font-size: x-small;
            font-weight: 700;

            line-height: 1.4;
          "
          [ngClass]="{
            cartWarningLightColor:
              coupon.validCombo && coupon.validDate && !coupon.validMinOrder
          }"
          *ngIf="
            coupon.appliesToOrderGreaterThan &&
            coupon.appliesToOrderGreaterThan !== '0'
          "
        >
          {{
            "reservation-app.cart-active-coupons.minimum-order" | translate
          }}&nbsp;{{ coupon.appliesToOrderGreaterThan }}€
        </p>

        <p
          style="font-size: x-small; font-weight: 700; line-height: 1.4"
          *ngIf="
            (coupon.discountType === 'percent' ||
              coupon.discountType === 'combined') &&
            coupon.maxDiscountAmount &&
            coupon.maxDiscountAmount !== '0'
          "
        >
          <ion-text>
            {{
              "cart.cart-components.cart-active-coupons.maximum-discount-amount"
                | translate
            }}&nbsp;{{ coupon.maxDiscountAmount }}€
          </ion-text>
        </p>

        <p
          *ngIf="!coupon.product_id"
          style="
            font-size: x-small;
            font-weight: 700;

            line-height: 1.4;
          "
        >
          {{
            "reservation-app.cart-active-coupons.cant-used-with-promo-products"
              | translate
          }}
        </p>

        <p
          *ngIf="coupon.preorder_only"
          style="
            font-size: x-small;
            font-weight: 700;

            line-height: 1.4;
          "
        >
          <ion-text color="danger">
            {{
              "reservation-app.cart-active-coupons.coupon-can-be-used-only-for-preorder"
                | translate
            }}
          </ion-text>
        </p>

        <p *ngIf="coupon.status === 'pending_confirmation'">
          <ion-text color="danger">
            {{
              "discount-coupons.coupons-item.coupon-must-be-confirmed-from-store"
                | translate
            }}
          </ion-text>
        </p>

        <p
          *ngIf="coupon.online_payment_only"
          style="
            font-size: x-small;
            font-weight: 700;

            line-height: 1.4;
          "
        >
          <ion-text color="danger">
            {{
              "reservation-app.cart-active-coupons.coupon-can-be-used-only-for-online-payment"
                | translate
            }}
          </ion-text>
        </p>

        <p
          *ngIf="coupon.only_mobile_apps && !nativePlatform"
          style="
            font-size: x-small;
            font-weight: 700;

            line-height: 1.4;
          "
        >
          <ion-text color="danger">
            {{
              "cart.cart-components.cart-active-coupons.coupon-can-be-used-only-from-mobile-apps"
                | translate
            }}
          </ion-text>
        </p>

        <div>
          <ion-badge
            *ngIf="coupon.status"
            [color]="calculateBadgeColor(coupon)"
          >
            {{
              "reservation-app.discount-coupons.reservation-coupons-item." +
                coupon.status | translate
            }}
            <ion-text *ngIf="coupon.order_id && coupon.status === 'used'"
              >#{{ coupon.order_id }}</ion-text
            >
          </ion-badge>
          <ion-badge
            *ngIf="!coupon.validCombo && coupon.validDate"
            color="danger"
          >
            <ion-text class="cartWarningLightColor">
              {{
                "reservation-app.cart-active-coupons.coupon-cannot-be-combined-with-your-other-choices"
                  | translate
              }}
            </ion-text>
          </ion-badge>
        </div>
      </ion-label>
      <ion-checkbox
        [disabled]="finalPriceLoading || disableCheckbox"
        [(ngModel)]="coupon.couponCheckbox"
        (ionChange)="clickCheckboxCoupon(coupon)"
      >
      </ion-checkbox>
      <div
        style="position: absolute; bottom: 5px; right: 10px; font-size: x-small"
        *ngIf="coupon && coupon.points"
      >
        {{
          "reservation-app.discount-coupons.reservation-coupons-item.from_lowercase"
            | translate
        }}
        {{ coupon.points }}
        {{
          "reservation-app.discount-coupons.reservation-coupons-item.points"
            | translate
        }}
      </div>
    </ion-item>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row style="width: 100%">
      <ion-col class="ion-text-center">
        <ion-button (click)="closeModal()" shape="round">
          {{ "continue" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
